/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { AlertProps, Button, Stack } from "@mui/material";
import AlertLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertLegalbird.tsx";
import AlertContentLegalbird from "@/src/components/legalbird/AlertLegalbird/AlertContentLegalbird.tsx";

export default function AlertStyleguide() {
  return (
    <>
      <AlertExamples variant={"success"} />
      <AlertExamples variant={"warning"} />
      <AlertExamples variant={"error"} />
    </>
  );
};

function AlertExamples({ variant }: { variant: NonNullable<AlertProps["severity"]> }) {
  const title = variant[0].toUpperCase() + variant.slice(1);

  return (
    <>
      <StyleguideView title={title}>
        <Stack spacing={"1.5rem"}>
          <AlertLegalbird severity={variant}>
            <AlertContentLegalbird title={"Lorem ipsum dolor sit amet,"} />
          </AlertLegalbird>
          <AlertLegalbird severity={variant}>
            <AlertContentLegalbird
              title={"Lorem ipsum dolor sit amet,"}
              subtitle={"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut"}
              actions={
                <Button variant={"outlined"} color={variant}>
                  Lorem ipsum
                </Button>
              }
            />
          </AlertLegalbird>
          <AlertLegalbird severity={variant}>
            <AlertContentLegalbird
              title={"Lorem ipsum dolor sit amet,"}
              subtitle={"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut"}
              actions={
                <Button variant={"outlined"} color={variant}>
                  Lorem ipsum
                </Button>
              }
              description={
                <>
                  <strong>Lorem ipsum dolor sit amet, consetetur sadipscing elitr,</strong> sed diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
                  est Lorem ipsum dolor sit amet.
                </>
              }
            />
          </AlertLegalbird>
        </Stack>
      </StyleguideView>
      <StyleguideView title={title} subtitle={"Variant Hintbox"}>
        <AlertLegalbird severity={variant} variant={"hint"}>
          <AlertContentLegalbird
            title={"Lorem ipsum dolor sit amet,"}
            subtitle={
              "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea "
            }
          />
          <AlertContentLegalbird
            title={"Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut"}
            subtitle={
              "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea dolore magna aliquyam erat"
            }
            actions={
              <Button variant={"outlined"} color={variant}>
                Lorem ipsum
              </Button>
            }
          />
        </AlertLegalbird>
      </StyleguideView>
    </>
  );
}
